import {
  Home, Zap, Wrench, Tent, Settings, Package, ShoppingCart, Users, FileText, Calendar, BarChart3,
  ClipboardList, ClipboardCheck, Banknote, LayoutList, Car, Calculator, Bot, Shield, ScrollText, Boxes,
  Bed, Building2, BookOpen, Briefcase, Mail, Newspaper, Heart, Coins, Wallet, Landmark, GraduationCap,
  School, Baby, Church, Music, Mic, Camera, Lightbulb, Map, Archive, FolderOpen, Contact, Megaphone,
  MessageSquare, Globe, Star, Circle,
  Cloud, Server, Key, CreditCard, RefreshCw, HardDrive, Lock, Bell, Database, Activity, Layers, Search,
  type LucideIcon,
} from 'lucide-react';

/**
 * Lucide icons selectable for menu entries, also used for settings tabs. A fixed set keeps the bundle
 * small (no full icon library); names are Lucide's PascalCase names, as
 * stored in menu_permissions.icon. Extend the list when an icon is missing.
 */
export const menuIcons: Record<string, LucideIcon> = {
  Home, Zap, Wrench, Tent, Settings, Package, ShoppingCart, Users, FileText, Calendar, BarChart3,
  ClipboardList, ClipboardCheck, Banknote, LayoutList, Car, Calculator, Bot, Shield, ScrollText, Boxes,
  Bed, Building2, BookOpen, Briefcase, Mail, Newspaper, Heart, Coins, Wallet, Landmark, GraduationCap,
  School, Baby, Church, Music, Mic, Camera, Lightbulb, Map, Archive, FolderOpen, Contact, Megaphone,
  MessageSquare, Globe, Star, Circle,
  Cloud, Server, Key, CreditCard, RefreshCw, HardDrive, Lock, Bell, Database, Activity, Layers, Search,
};

export const menuIconNames = Object.keys(menuIcons).sort();

export function resolveMenuIcon(name: string | null | undefined, fallback?: LucideIcon): LucideIcon {
  return (name && menuIcons[name]) || fallback || Circle;
}
